import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import Icon from 'shared/components/Icon';

import theme from './MenuItem.scss';

const propTypes = {
  items: PropTypes.array,
  selectedItem: PropTypes.object,
  highlightedIndex: PropTypes.number,
  noResultMessage: PropTypes.object,
  iconName: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  mediaResized: PropTypes.bool,

  getItemProps: PropTypes.func.isRequired,
};

const defaultProps = {
  items: null,
  selectedItem: null,
  highlightedIndex: null,
  noResultMessage: null,
  iconName: '',
  size: 'small',
  mediaResized: false,
};

const emptyClick = (event) => {
  event.preventDefault();
  event.stopPropagation();
};

const MenuItem = ({
  items,
  selectedItem,
  highlightedIndex,
  noResultMessage,
  iconName,
  size,
  mediaResized,
  getItemProps,
}) => (
  <Choose>
    <When condition={ items && items.length }>
      { items.map((item, index) => {
        const props = getItemProps({ key: item.key, index, item });

        return (
          <div
            key={ item.key }
            className={ classnames({
              [theme[size]]: size,
              [theme.mediaResized]: mediaResized,
              [theme.highlightedItem]: selectedItem === item || highlightedIndex === index,
              [theme.itemWithIcon]: iconName || (item && item.iconName),
              [theme.disabled]: item.disabled,
            }, theme.item) }
            aria-selected={ props['aria-selected'] }
            role="option"
            onClick={ !item.disabled ? props.onClick : emptyClick }
            onMouseDown={ !item.disabled ? props.onMouseDown : emptyClick }
          >
            { (iconName && !item.iconName) && <Icon name={ iconName } /> }
            { item.iconName && <Icon name={ item.iconName } /> }
            { item.value }
          </div>
        );
      }) }
    </When>
    <When condition={ noResultMessage }>
      <div className={ classnames({
        [theme[size]]: size,
        [theme.mediaResized]: mediaResized,
      }, theme.item, theme.noResultsItem) }
      >
        <FormattedMessage { ...noResultMessage } />
      </div>
    </When>
  </Choose>
);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

export default MenuItem;
